import React from "react";
import { Link } from "react-router-dom";

const AboutUsVisionSection = () => {
  return (
    <>
      <div class="solution about-solution sp">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="images">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="image">
                      <img src="/assets/img/about/visiton-img1.png" alt="" />
                    </div>
                  </div>

                  
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="heading1">
                <span class="span">
                  <img src="/assets/img/icons/span1.png" alt="" /> Our Vision
                </span>
                <h2>
                  Driving Innovation: Our Vision at IBRLIVE Private Limited
                </h2>
                <div class="space16"></div>
                <p>
                  We envision a world where cross-border financial operations
                  are effortless and data-driven. Through our Exchange Rate API,
                  we strive to support the next generation of digital platforms,
                  startups, and financial institutions by providing them with
                  the tools they need to build, scale, and innovate in the
                  international currency space.
                </p>

                {/* <div class="item-box">
                            <div class="icon">
                              <div class="">
                                <img src="/assets/img/icons/about-solution-iocn1.png" alt=""/>
                              </div>
                            </div>
                            <div class="">
                              <h3><a href="#">Network Infrastructure Solutions</a></h3>
                              <div class="space10"></div>
                              <p>Build a reliable and secure network infrastructure that <br/> supports your business operations enables seamless</p>
                            </div>
                          </div> */}

                {/* <div class="item-box">
                            <div class="icon">
                              <div class="">
                                <img src="/assets/img/icons/about-solution-iocn2.png" alt=""/>
                              </div>
                            </div>
                            <div class="">
                              <h3><a href="#">Managed It Services</a></h3>
                              <div class="space10"></div>
                              <p>Focus on your core business activities while we take <br/> care of your IT needs with our managed IT services.</p>
                            </div>
                          </div> */}

                <div class="space30"></div>
                <div class="">
                  <Link class="theme-btn1" to="/dashboard">
                    Start Free Plan{" "}
                    <span>
                      <i class="fa-solid fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUsVisionSection;
